import { Fragments } from '~/graphql';

const getDefaultPaymentMethod = (
    userPaymentMethods: Array<Fragments.UserPaymentMethodFieldsFragment>
) => userPaymentMethods.find((userPaymentMethod) => userPaymentMethod.default);

export default getDefaultPaymentMethod;
